import useSWR from 'swr';
import { TeamStatsFragment } from '@amf/shared/types/graphql';

const getKey = (id?: string, league?: string, season?: string) => {
  if (!id) return null;
  const params = new URLSearchParams({ id });
  if (league) params.append('league', league);
  if (season) params.append('season', season);
  return `/api/team/stats?${params}`;
};

function useTeamStats(id?: string, leagueId?: string, seasonId?: string) {
  const { data, error } = useSWR<TeamStatsFragment | null>(getKey(id, leagueId, seasonId));

  return {
    error,
    stats: data,
    loading: !data && !error,
  };
}

export default useTeamStats;
